module.exports = __webpack_public_path__ + "062614350cc5e81a29a0e190c2d48422.png";